import type { HelpFile } from '../../types/help'
import { OverviewSubPageTestIds } from '../../../testids/OverviewSubPageTestIds'

export const overviewSubPageHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [OverviewSubPageTestIds.connectorInfoCard]:
      'Target system, connector type, and current status of this inbound connector.',
    [OverviewSubPageTestIds.scheduleCard]:
      'Synchronisation schedule — cron expression and next scheduled run time.',
    [OverviewSubPageTestIds.lastSyncCard]:
      'Last synchronisation result — timestamp, duration, and record counts.',
    [OverviewSubPageTestIds.manualSyncCard]:
      'Trigger a manual synchronisation run outside the regular schedule.',
    [OverviewSubPageTestIds.cardTitleManualSync]:
      'Trigger a manual sync run on demand.',
    [OverviewSubPageTestIds.btnSyncFull]:
      'Run a full sync — re-imports every record from the source system.',
    [OverviewSubPageTestIds.btnSyncDelta]:
      'Run a delta sync — only re-imports records that changed since the last completed sync. Available for connectors that support incremental fetch (REST, SCRIPT, SAP HCM).',
    [OverviewSubPageTestIds.btnSyncPreview]:
      'Run a preview sync — calculates changes without applying them.',
    [OverviewSubPageTestIds.syncConfirmDialog]:
      'Confirm the sync action — full or preview — before it starts.',
    [OverviewSubPageTestIds.targetSystemLink]:
      'Open the target system this connector imports records into.',
  },
}
